import React from "react";
import { Routes, Route } from "react-router-dom";
import LinkBlitzLanding from "./components/LinkBlitzLanding";
import PrivacyPolicy from "./components/PrivacyPolicy";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LinkBlitzLanding />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default App;
